function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n\n    @media ",
        " {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n    }\n    @media ",
        " {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: ",
        ";\n    margin: auto; /* centers the content in the page */\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-top: 24px;\n\n    @media ",
        " {\n      padding-top: 16px;\n    }\n    @media ",
        " {\n      padding-top: 8px;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: 24px;\n\n    @media ",
        " {\n      padding-bottom: 16px;\n    }\n    @media ",
        " {\n      padding-bottom: 8px;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { css } from "styled-components";
import { MaterialBreakpointDown } from "../themeStyles";
/**
 * These values are per KM Carbon (http://shortn/_VrNzZ7zTtJ) from GM2:
 * https://material.io/design/layout/responsive-layout-grid.html#columns-gutters-and-margins
 */ var CONTENT_GUTTER = {
    DESKTOP: "48px",
    TABLET: "24px",
    MOBILE: "16px"
};
var CONTENT_MAX_WIDTH = "1200px";
/**
 * Spacing in KM aligning to Kaggle Design team usage.
 * Carbon: http://shortn/_CZs7XdSmZp
 */ export var spacing = {
    /**
   * Maximum width for the content body of a page. See KM Carbon:
   * http://shortn/_LTUvka46ON
   */ maxContentWidth: CONTENT_MAX_WIDTH,
    /**
   * Applies responsive left + right padding to a top-level content container.
   */ withContentPadding: css(_templateObject(), CONTENT_GUTTER.DESKTOP, CONTENT_GUTTER.DESKTOP, MaterialBreakpointDown.TABLET, CONTENT_GUTTER.TABLET, CONTENT_GUTTER.TABLET, MaterialBreakpointDown.PHONE, CONTENT_GUTTER.MOBILE, CONTENT_GUTTER.MOBILE),
    /** Centers and applies a max-width to a top-level content container. */ withContentBody: css(_templateObject1(), CONTENT_MAX_WIDTH),
    /** Applies responsive top padding to a top-level content container. */ withContentTopPadding: css(_templateObject2(), MaterialBreakpointDown.TABLET, MaterialBreakpointDown.PHONE),
    /** Applies responsive bottom padding to a top-level content container. */ withContentBottomPadding: css(_templateObject3(), MaterialBreakpointDown.TABLET, MaterialBreakpointDown.PHONE)
};
